/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { CalendarTaskView, ICalendarTaskViewOwnProps, ICalendarTaskViewStateProps, ICalendarTaskViewDispatchProps } from "../../components/calendarTask/calendarTaskView";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ICalendarTaskViewOwnProps): ICalendarTaskViewStateProps {
    if (!applicationState?.calendarTask?.calendarTaskView) {
        return {
            user: applicationState?.user,
            calendarTaskView: null,
            lastOpenedCalendarTaskId: null,
        };
    }
    const calendarTaskView = applicationState.calendarTask.calendarTaskView;
    return {
        user: applicationState.user,
        calendarTaskView,
        lastOpenedCalendarTaskId: null,
    };
}

export function mapDispatchToProps(dispatch: storeEffects.CalendarTaskThunkDispatch): ICalendarTaskViewDispatchProps {
    return {
        loadCalendarTasks: (startDate: number, endDate: number, filter: string, stateId: string, categoryId: string) => dispatch(storeEffects.getCalendarTaskView(startDate, endDate, filter, stateId, categoryId)),
        removeCalendarTask: (id: string) => dispatch(storeActions.calendarTaskViewRemove(id)),
        resetCalendarTasks: () => dispatch(storeActions.calendarTaskViewReset()),
        setLastOpenedCalendarTaskId: (id: string) => dispatch(storeActions.calendarTaskViewSetLastOpened(id)),
        setReturnUrl: (url: string) => dispatch(storeActions.calendarTaskEditSetReturnUrl(url)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<ICalendarTaskViewStateProps, ICalendarTaskViewDispatchProps, ICalendarTaskViewOwnProps>(mapStateToProps, mapDispatchToProps)(CalendarTaskView);